"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var filter_1 = require("./filter");
var Finding = (function () {
    function Finding() {
    }
    Finding.findPromoCruise = function (cruises) {
        var filteredCruises = filter_1.Filter.filterCruisesByAvailability(cruises);
        var sortedCruises = lodash_1.orderBy(filteredCruises, function (c) { return c.price; });
        return lodash_1.find(sortedCruises, function (cruise) { return cruise.promotionCategories.length > 0; });
    };
    Finding.findPromoCruiseCheapest = function (cruises) {
        var filteredCruises = filter_1.Filter.filterCruisesByAvailability(cruises);
        var cheapestCruise = lodash_1.sortBy(filteredCruises, ['price'])[0];
        if (cheapestCruise && cheapestCruise.cabinCategories) {
            var sortedCabinCategories = lodash_1.sortBy(cheapestCruise.cabinCategories, [
                'price',
            ]);
            cheapestCruise.promotionCategories = [sortedCabinCategories[0].id];
        }
        return cheapestCruise;
    };
    Finding.findPromoCategory = function (cabinCats, promoCats) {
        var filteredCats = lodash_1.filter(cabinCats, function (cc) { return promoCats.includes(cc.id); });
        return lodash_1.sortBy(filteredCats, ['price'])[0];
    };
    Finding.findStartPort = function (cruise) {
        return lodash_1.head(cruise.ports);
    };
    Finding.findEndPort = function (cruise) {
        return lodash_1.find(cruise.ports, function (port) {
            var lastPort = lodash_1.last(lodash_1.get(cruise, 'journeys[0].segments'));
            return port.id === (lastPort ? lastPort.portID : undefined);
        });
    };
    Finding.findShip = function (cruise) {
        return lodash_1.head(cruise.ships);
    };
    return Finding;
}());
exports.Finding = Finding;
//# sourceMappingURL=finding.js.map